import React from "react";
import { ModalBuilder, Modal, Table } from "@redriver/cinnamon";

const RemoveReturnOnInvestmentModal = ({
  submitAction,
  onSubmitted,
  returnOnInvestment,
}) => (
  <ModalBuilder
    submitAction={submitAction}
    submitParams={returnOnInvestment.id}
    onSubmitted={onSubmitted}
    renderTrigger={(showModal) => (
      <Table.MenuItem onClick={showModal}>Delete</Table.MenuItem>
    )}
    renderModal={(modalProps) => (
      <Modal.Delete
        {...modalProps}
        header="Remove ROI"
        submitLabel="Remove ROI"
      >
        <p>
          {"Are you sure you wish to remove '"}
          {returnOnInvestment.name}
          {"'?"}
        </p>
      </Modal.Delete>
    )}
  />
);

export default RemoveReturnOnInvestmentModal;
